/**
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html#form-fields-stacked)
 */
/**
 * MuiFormLabel
 */
const MuiFormLabel = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      color: theme.palette.text.primary
    })
  }
};
export default MuiFormLabel;